// The words for a paused or view-only round (billing stage 6): the server's answer to a refused change
// (functions/lib/round-access.ts) and the line under the top bar (src/access-line.ts). No em dashes, nothing about
// paying inside the iPhone app (Apple 3.1.3).

export type AccessKind = 'open' | 'paused' | 'view_only'
// why: free months ended with no card, a payment unpaid, or a plan that ended (cancelled). stopped: view only, and the
// plan has stopped taking payments (stage 6d), said only once it really has.
export interface AccessFacts { access: AccessKind; why: 'free_time_ended' | 'unpaid' | 'plan_ended' | null; since: string | null; stopped?: boolean }

export const PAUSED_WORDS = {
  customers: "Your round is paused, so adding customers is off until it's open again.",
  booking: "Your round is paused, so booking new visits is off until it's open again. Jobs already booked can still be marked done.",
  messages: "Your round is paused, so sending messages from Roundly is off until it's open again.",
} as const
export const VIEW_ONLY_WORDS = "Your round is view and download only, so nothing can be changed until it's open again."

// The line under the top bar: owners on the web are told how to open it again, inside the iPhone app nothing about
// paying; workers are told what still works.
export function accessWords(a: AccessFacts | undefined, role: string | undefined, inApp: boolean): string | null {
  if (!a || a.access === 'open') return null
  if (role === 'worker') {
    return a.access === 'view_only'
      ? 'This round is view only for now, so nothing can be changed. Your boss can sort it out.'
      : 'This round is paused, so adding customers, booking and messages are off. You can still mark booked jobs done and take payments.'
  }
  // Inside the iPhone app: what the round can do, never why (free months and payments are the website's to mention).
  if (inApp) {
    return a.access === 'view_only' ? 'Your round is view and download only for now.'
      : 'Your round is paused for now. You can still see everything, download, and mark booked jobs done.'
  }
  if (a.access === 'view_only') return `A payment is 30 days late, so your round is view and download only${a.stopped ? ' and your plan has stopped' : ''}. Pay it on Your plan to open everything again.`
  if (a.why === 'plan_ended') return 'Your plan has ended, so your round is paused. You can still see everything, download, and mark booked jobs done. Add a card on Your plan to start it again.'
  return a.why === 'free_time_ended'
    ? 'Your free months have ended, so your round is paused. You can still see everything, download, and mark booked jobs done. Add a card on Your plan to open everything again.'
    : 'A payment is 14 days late, so your round is paused. You can still see everything, download, and mark booked jobs done. Pay it on Your plan to open everything again.'
}
